(() => {
  const initialize = (root = document) => {
    root.querySelectorAll("[data-gl-editorial-home]").forEach((home) => {
      if (home.dataset.glReady === "true") return;
      home.dataset.glReady = "true";

      requestAnimationFrame(() => home.classList.add("is-loaded"));

      const revealNodes = home.querySelectorAll("[data-gl-reveal]");
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.dataset.glVisible = "true";
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: "0px 0px -7%" });
        revealNodes.forEach((node) => observer.observe(node));
      } else {
        revealNodes.forEach((node) => { node.dataset.glVisible = "true"; });
      }

      home.addEventListener("click", (event) => {
        const link = event.target.closest("[data-gl-track]");
        if (!link) return;
        const payload = {
          placement: link.dataset.glTrack || "",
          destination: link.getAttribute("href") || "",
          path: window.location.pathname
        };
        if (window.Shopify?.analytics?.publish) {
          window.Shopify.analytics.publish("genius_loci:homepage_action", payload);
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "gl_homepage_action", ...payload });
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize());
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
})();
